import { isRouteErrorResponse } from 'react-router';
import { isRESTAPIError } from '@gonfalon/errors/RESTAPIError';
import { trackError } from '@gonfalon/telemetry/trackError';
import type { RUMCustomErrorContext } from '@gonfalon/telemetry/types';

import { getHTTPStatusSeverity } from './getHTTPStatusSeverity';
import { wrapRouteError } from './internal/wrapRouteError';

export function trackRouteError(error: unknown, context: RUMCustomErrorContext = {}) {
  if (!error) {
    return;
  }

  const routeErrorContext: RUMCustomErrorContext = { ...context };

  if (isRESTAPIError(error)) {
    routeErrorContext.url = error.url;
    routeErrorContext.metadata = {
      ...routeErrorContext.metadata,
      status: error.status,
      code: error.code,
      url: error.url,
    };

    if (!routeErrorContext.severity) {
      routeErrorContext.severity = getHTTPStatusSeverity(error.status);
    }
  } else if (isRouteErrorResponse(error) && !routeErrorContext.severity) {
    // Responses thrown from loaders/actions carry an HTTP status too.
    routeErrorContext.severity = getHTTPStatusSeverity(error.status);
  }

  // Remaining route errors are render crashes; default to route-level severity.
  trackError(wrapRouteError(error), { ...routeErrorContext, severity: routeErrorContext.severity ?? 'high' });
}
